import { routes } from '@common/routes';
import { useCallback } from 'react';

import history from '~/browserHistory';

export const useGoHome = () => {
    return useCallback(() => history.push(routes.root), [history]);
};
